/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { API_URL } from '../../common/enum/enum'

export const getArticlesByClusterId = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles?clusterId=${req.clusterId}&size=${req.size}&offset=${req.offset}`);
}

export const getLatestArticles = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/latest?size=${req.size}&offset=${req.offset}`);
}

export const getLatestTypeArticles = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/latest?type=${req.type}&size=${req.size}&offset=${req.offset}`);
}

export const getArticlesByArticleId = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/detail?id=${req}`);
}

export const getArticlesByLink = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/detail?link=${req}`);
}

export const getArticlesByCategoryId = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/byCategory/${req.id}?size=${req.size}&offset=${req.offset}`);
}

export const getArticlesYoutube = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/latest?type=YOUTUBE_SHORT&size=${req.size}&offset=${req.offset}`);
}

export const getArticlesTiktok = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/latest?type=TIKTOK&size=${req.size}&offset=${req.offset}`);
}

export const mostViewedArticles = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/mostView?size=${req.size}&offset=${req.offset}`);
}

export const mostViewdArticlesByCategoryId = (req: any) => {
    return axios.get(`${API_URL.HOST}/articles/mostView?categoryId=${req.id}&size=${req.size}&offset=${req.offset}`);
}